import React from 'react';
import { SectionTab, ImagesGrid } from 'polotno/side-panel';
import { observer } from 'mobx-react-lite';
import { useInfiniteAPI } from 'polotno/utils/use-api';
import { getImageSize } from 'polotno/utils/image';

import MdPhotoLibrary from '@meronex/icons/md/MdPhotoLibrary';

import { InputGroup, Tabs, Tab, Tag } from '@blueprintjs/core';

var url;
var key;
var setSrcUrl;

const UnsplashList = ({ query, store }) => {
  const { data, isLoading, loadMore, setQuery } = useInfiniteAPI({
    defaultQuery: query,
    getAPI: ({ page, query }) => {
      url = 'https://api.unsplash.com/search/photos';
      key = '113707ee9dd15c270b62f4767edeb996d6844217858249610f6452ac37e3dc7b';
      setSrcUrl = `${url}?query=${query}&per_page=20&page=${page - 1}&client_id=${key}`;

      return setSrcUrl;
    },
    getSize: (res) => Math.floor(res.count / res.limit),
  });

  React.useEffect(() => {
    setQuery(query);
  }, [query]);

  return (
    <ImagesGrid
      images={data?.map((data) => data.results).flat()}
      getPreview={(results) => results.urls.small}
      onSelect={async (results, pos) => {
        fetch(`https://api.unsplash.com/photos?id=${results.id}&client_id=${key}`);
        const { width, height } = await getImageSize(results.urls.regular);
        store.activePage.addElement({
          type: 'image',
          src: results.urls.regular,
          width,
          height,
          x: (pos?.x || store.width / 2) - width / 2,
          y: (pos?.y || store.height / 2) - height / 2,
        });
      }}
      rowsNumber={2}
      isLoading={isLoading}
      loadMore={loadMore}
    />
  );
};

const PixabayList = ({ query, store }) => {
  const { data, isLoading, loadMore, setQuery } = useInfiniteAPI({
    defaultQuery: query,
    getAPI: ({ page, query }) => {
      url = 'https://pixabay.com/api/';
      key = '6255953-a1fe005d5657cfc4f3644afae';
      setSrcUrl = `${url}?q=${query}&per_page=20&page=${page + 1}&key=${key}`;

      return setSrcUrl;
    },
    getSize: (res) => Math.floor(res.count / res.limit),
  });

  React.useEffect(() => {
    setQuery(query);
  }, [query]);

  return (
    <ImagesGrid
      images={data?.map((data) => data.hits).flat()}
      getPreview={(hits) => hits.previewURL}
      onSelect={async (hits, pos) => {
        fetch(`https://pixabay.com/api/?key=${key}&id=${hits.id}`);
        const { width, height } = await getImageSize(hits.largeImageURL);
        store.activePage.addElement({
          type: 'image',
          src: hits.largeImageURL,
          width,
          height,
          x: (pos?.x || store.width / 2) - width / 2,
          y: (pos?.y || store.height / 2) - height / 2,
        });
      }}
      rowsNumber={2}
      isLoading={isLoading}
      loadMore={loadMore}
    />
  );
};

export const MaImagesPanel = observer(({ store }) => {
  const [tab, setTab] = React.useState('unsplash');
  const [query, setQuery] = React.useState('architecture');

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Tabs large>
        <Tab id='unsplash' title=''>
          <button
            className='tab-btn'
            onClick={() => {
              setTab('unsplash');
            }}
          >
            Unsplash
          </button>
        </Tab>
        <Tab id='pixabay' title=''>
          <button
            className='tab-btn'
            onClick={() => {
              setTab('pixabay');
            }}
          >
            Pixabay
          </button>
        </Tab>
      </Tabs>
      <InputGroup
        leftIcon='search'
        placeholder='Procurar...'
        onChange={(e) => setQuery(e.target.value)}
        style={{ marginBottom: '20px' }}
      />
      <div className='tags-holder'>
        <Tag
          large
          minimal
          round
          interactive
          onClick={() => {
            setQuery('Real Estate');
          }}
        >
          Real Estate
        </Tag>
        <Tag
          large
          minimal
          round
          interactive
          onClick={() => {
            setQuery('House');
          }}
        >
          House
        </Tag>
        <Tag
          large
          minimal
          round
          interactive
          onClick={() => {
            setQuery('Building');
          }}
        >
          Building
        </Tag>
        <Tag
          large
          minimal
          round
          interactive
          onClick={() => {
            setQuery('Apartment');
          }}
        >
          Apartment
        </Tag>
        <Tag
          large
          minimal
          round
          interactive
          onClick={() => {
            setQuery('Room');
          }}
        >
          Room
        </Tag>
        <Tag
          large
          minimal
          round
          interactive
          onClick={() => {
            setQuery('Living Room');
          }}
        >
          Living Room
        </Tag>
      </div>
      {tab === 'unsplash' ? (
        <UnsplashList query={query} store={store} />
      ) : (
        <PixabayList query={query} store={store} />
      )}
    </div>
  );
});

export const MaImagesSection = {
  name: 'photos',
  Tab: (props) => (
    <SectionTab name='Imagens' {...props}>
      <MdPhotoLibrary />
    </SectionTab>
  ),
  Panel: MaImagesPanel,
};
